import script from "./AppInfiniteScroll.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppInfiniteScroll.vue?vue&type=script&lang=ts&setup=true"

import "./AppInfiniteScroll.vue?vue&type=style&index=0&id=6a1bafdc&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a1bafdc"]])

export default __exports__